import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { LoaderComponent } from '@common/components/loader/loader.component';
import { NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-post-states',
  imports: [LoaderComponent, NgbProgressbarModule],
  templateUrl: './post-states.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./post-states.component.scss']
})
export class PostStatesComponent {
  @Input() isPosting: boolean = false;
  @Input() isPostingOver: boolean = false;
  @Input() postError: { errorCode: number; message: string } | null = null;
  @Input() readyMessage: string = '';
  @Input() postingMessage: string = '';
  @Input() completeMessage: string = '';
  @Input() definedProgress: boolean = false;
  @Input() progress: number = 0;
}
